// extracted by mini-css-extract-plugin
export default {"items":"RoadmapSection_items__cs5Vz"};